import * as PropTypes from 'prop-types';
import * as React from 'react';

const EVERYWHERE_ELSE_CODE = 'XX';

const shippingRegionName = (shippingRegion) => {
  if (shippingRegion.code === EVERYWHERE_ELSE_CODE) {
    return I18n.t('shippingRates.everywhereElse');
  }

  return shippingRegion.name;
};

const ShippingRegionOption = props =>
  (<option value={props.shippingRegion.code}>
    {shippingRegionName(props.shippingRegion)}
   </option>);

ShippingRegionOption.propTypes = {
  shippingRegion: PropTypes.object.isRequired,
};

export default ShippingRegionOption;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_rates/shipping_region_option.jsx